module.exports = __webpack_public_path__ + "static/media/slide-image-5-small-min-new.eb12e1a2.jpg";